<template>
  <VFiltersPopup
    popup-class="shipments-outer-filter"
    :title-list="titleList"
    @submit="applyFilters"
    @clear="clearFilters"
  >
    <section class="outer-filter-container">
      <VButtonGroup>
        <VButton
          :theme="draft.isMine ? 'primary' : 'default'"
          @click="draft.isMine = true"
        >
          <template #icon>
            <VIcon material="person_black" />
          </template>
          <slot name="label-mine">
            Мои отгрузки
          </slot>
        </VButton>
        <VButton
          :theme="draft.isMine ? 'default' : 'primary'"
          @click="draft.isMine = false"
        >
          <template #icon>
            <VIcon material="filter_alt" />
          </template>
          <slot name="label-all">
            Все отгрузки
          </slot>
        </VButton>
      </VButtonGroup>

      <div class="wrap">
        <VSelectV2
          v-model="draft.responsible"
          placeholder="Выберите ответственного"
          :disabled="draft.isMine"
          layout="vertical"
          :data="({ pattern }) => PersonsService.searchPersons(pattern, $core.currentPartner!.id)"
        />
      </div>
    </section>
  </VFiltersPopup>
</template>

<style src="./ShipmentsPageFilter.scss" />

<script lang="ts">

import VFiltersPopup from '@/components/VFiltersPopup/VFiltersPopup.vue';
import PersonsService from "@/domains/Persons/PersonsService";
import ShipmentsPageFilter
  from "@/domains/Shipments/components/ShipmentsPageFilter/ShipmentsPageFilter";

export default defineComponent({
  name: 'ShipmentsRegistryFilterComponent',

  components: {
    VFiltersPopup,
  },

  emits: [ShipmentsPageFilter.Events.Updated],

  props: {
    filters: {
      type: Object as PropType<ShipmentsPageFilter>,
      required: true,
    }
  },

  data() {
    return {
      PersonsService,
      draft: this.$core.utils.cloneDeep(this.filters),
    };
  },

  computed: {
    titleList(): string[] {
      const texts: string[] = [];

      if (this.filters.responsible?.name) {
        texts.push(this.filters.responsible.name);
      }

      return texts;
    },
  },

  methods: {
    applyFilters(): void {
      this.draft.apply();
      this.$emit(ShipmentsPageFilter.Events.Updated, this.draft);
      this.draft = this.$core.utils.cloneDeep(this.draft);
    },

    clearFilters(): void {
      this.filters.reset();
      this.draft = this.$core.utils.cloneDeep(this.filters);
      this.$emit(ShipmentsPageFilter.Events.Updated, this.filters);
    },
  },
});
</script>
